module.exports = __webpack_public_path__ + "static/media/blog-1.b5172e94.jpg";